import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { AdvancedFilterRow, SingleSelectionAdvancedFilter } from 'shared/components/AdvancedFilter';
import { InlineFilterGroup } from 'shared/components/InlineFilterGroup';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectOfferTypeFilter } from 'shared/selectors/advancedFilters';
import { SpecialPromoContainer } from './containers/SpecialPromoContainer';

export const OfferTypeContainer: FC = () => {
  const { label, value, options } = useSelector(selectOfferTypeFilter);

  const onChange = useFilterChangeCallback();

  const handleOfferTypeChange = useCallback(
    (newValue: boolean | null) => {
      onChange({ action: 'setFromDeveloper', arguments: [newValue] });
    },
    [onChange],
  );

  return (
    <AdvancedFilterRow label={label}>
      <InlineFilterGroup>
        <SingleSelectionAdvancedFilter value={value} options={options} onFilterChange={handleOfferTypeChange} />
      </InlineFilterGroup>
      <SpecialPromoContainer />
    </AdvancedFilterRow>
  );
};
